import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id DF9D47EE-157B-4E1E-85CE-A043E5F2AE51
 * name temperature-kelvin
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/temperature-kelvin.svg
 * tags
 * - Weather 
 */
export const TemperatureKelvinIcon = createSvgIcon(<><path d="M7,5H10V11L15,5H19L13.88,10.78L19,20H15.38L11.76,13.17L10,15.15V20H7V5Z" /></>, 'TemperatureKelvinIcon');
export default TemperatureKelvinIcon